/**
 * City PDP Also available (shop + popup wizards).
 * Venue/city-scoped — no slot/event/time gate.
 * Fills [data-workshop-sibling-promo] from WorkshopSiblingPromoData + city suffix.
 */
(function (global) {
  'use strict';

  var LABELS = {
    'mosaic-lamp-workshop': 'Mosaic Lamp Workshop',
    'mosaic-classes': 'Mosaic Lamp Classes',
    'mosaic-classess': 'Mosaic Lamp Classes',
    'mosaic-workshop': 'Mosaic Workshop',
    'ceramic-painting-workshop': 'Ceramic Painting Workshop',
    'ceramic-painting-classes': 'Ceramic Painting Classes',
    'ceramic-painting-classess': 'Ceramic Painting Classes',
    'flower-decorating': 'Flower Decorating',
    'flower-decoration': 'Flower Decorating',
    'resin-art-workshop': 'Resin Art Workshop',
    'resin-art': 'Resin Art Workshop',
    'resin-workshop': 'Resin Art Workshop',
    'resin-classes': 'Resin Art Workshop',
  };

  var FAMILY_RULES = [
    { re: /^(shop-mosaic|mosaic-lamp-workshop|mosaic-workshop|mosaic-classes|mosaic-classess)(-|$)/, canon: 'mosaic-lamp-workshop' },
    { re: /^(shop-ceramic|ceramic-painting-workshop|ceramic-painting-classes|ceramic-painting-classess)(-|$)/, canon: 'ceramic-painting-workshop' },
    { re: /^(shop-flower|flower-decorating|flower-decoration)(-|$)/, canon: 'flower-decorating' },
    { re: /^(shop-resin|resin-art-workshop|resin-art|resin-workshop|resin-classes)(-|$)/, canon: 'resin-art-workshop' },
  ];

  var SUFFIX_PREFIXES = [
    'mosaic-lamp-workshop-in-',
    'mosaic-lamp-workshop-',
    'mosaic-classes-',
    'mosaic-classess-',
    'mosaic-workshop-',
    'ceramic-painting-classes-in-',
    'ceramic-painting-classes-',
    'ceramic-painting-classess-',
    'ceramic-painting-workshop-',
    'resin-art-workshop-',
    'resin-workshop-',
    'resin-classes-',
    'resin-art-',
    'flower-decorating-',
    'flower-decoration-',
    'shop-mosaic-',
    'shop-ceramic-',
    'shop-resin-',
    'shop-flower-',
  ];

  var PROBE_TEMPLATES = [
    'mosaic-classes-',
    'mosaic-lamp-workshop-',
    'mosaic-lamp-workshop-in-',
    'ceramic-painting-classes-',
    'ceramic-painting-classes-in-',
    'resin-art-workshop-',
    'resin-classes-',
    'flower-decorating-',
  ];

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function slugify(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function workshopFamily(h) {
    h = String(h || '')
      .trim()
      .toLowerCase();
    if (!h) return '';
    for (var i = 0; i < FAMILY_RULES.length; i++) {
      if (FAMILY_RULES[i].re.test(h)) return FAMILY_RULES[i].canon;
    }
    return h;
  }

  function sameFamily(a, b) {
    var ca = workshopFamily(a);
    var cb = workshopFamily(b);
    return !!(ca && cb && ca === cb);
  }

  function suffixFromHandle(ph) {
    ph = String(ph || '')
      .trim()
      .toLowerCase();
    if (!ph) return '';
    for (var i = 0; i < SUFFIX_PREFIXES.length; i++) {
      if (ph.indexOf(SUFFIX_PREFIXES[i]) === 0) {
        var suf = ph.slice(SUFFIX_PREFIXES[i].length);
        if (suf) return suf;
      }
    }
    return '';
  }

  function citySuffix(root, productHandle) {
    var fromHandle = suffixFromHandle(productHandle);
    if (fromHandle) return fromHandle;
    var fromName = slugify(root && root.getAttribute('data-city-name'));
    if (fromName) return fromName;
    var key = String((root && root.getAttribute('data-city-key')) || '')
      .trim()
      .toLowerCase();
    if (!key) return '';
    var m = key.match(/^us-[a-z]{2}-(.+)$/);
    if (m && m[1]) return m[1];
    return key;
  }

  function parseData(sectionId) {
    var el = sectionId ? document.getElementById('WorkshopSiblingPromoData-' + sectionId) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function indexCatalog(data) {
    var byHandle = Object.create(null);
    var byFamily = Object.create(null);
    function add(entry) {
      if (!entry || !entry.handle) return;
      var h = String(entry.handle)
        .trim()
        .toLowerCase();
      if (!h) return;
      var row = {
        handle: h,
        title: String(entry.title || entry.label || LABELS[h] || h).trim(),
        url: String(entry.url || '/products/' + encodeURIComponent(h)).trim(),
        image: entry.image || '',
      };
      byHandle[h] = row;
      var fam = workshopFamily(h);
      if (fam && !byFamily[fam]) byFamily[fam] = row;
    }
    (data && data.siblingWorkshops ? data.siblingWorkshops : []).forEach(add);
    (data && data.workshopCatalog ? data.workshopCatalog : []).forEach(add);
    return { byHandle: byHandle, byFamily: byFamily };
  }

  function hostsFor(root, sectionId) {
    var sid = String(sectionId || (root && root.getAttribute('data-section-id')) || '');
    if (!sid) return [];
    var sel =
      '[data-workshop-sibling-promo][data-section-id="' +
      sid.replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
      '"]';
    var section = root && root.closest('.shopify-section');
    var list = section ? section.querySelectorAll(sel) : document.querySelectorAll(sel);
    return Array.prototype.slice.call(list || []);
  }

  function ensureHost(root, sectionId) {
    var hosts = hostsFor(root, sectionId);
    if (hosts.length) return hosts;
    var slot = root && root.querySelector('[data-wbw-promo-slot]');
    if (!slot) return [];
    var host = document.createElement('div');
    host.className = 'wbw-sibling-promo-host';
    host.setAttribute('data-workshop-sibling-promo', '');
    host.setAttribute('data-section-id', String(sectionId || ''));
    host.innerHTML =
      '<div class="wbw-sibling-promo-wrap" data-wbw-sibling-promo-wrap hidden aria-hidden="true">' +
      '<div class="wbw-sibling-promo-list" data-wbw-sibling-promo-list></div></div>';
    slot.appendChild(host);
    return [host];
  }

  function applyHosts(hosts, show, html) {
    (hosts || []).forEach(function (host) {
      if (!host) return;
      var wrap = host.querySelector('[data-wbw-sibling-promo-wrap]');
      var list = host.querySelector('[data-wbw-sibling-promo-list]');
      if (!wrap || !list) return;
      if (!show) {
        wrap.hidden = true;
        wrap.setAttribute('aria-hidden', 'true');
        list.innerHTML = '';
        return;
      }
      list.innerHTML = html;
      wrap.hidden = false;
      wrap.setAttribute('aria-hidden', 'false');
    });
  }

  function cardHtml(item, venueName) {
    var img = item.image
      ? '<span class="wbw-sibling-promo-card__media"><img class="wbw-sibling-promo-card__img" src="' +
        escapeHtml(item.image) +
        '" alt="" loading="lazy" width="400" height="300"></span>'
      : '<span class="wbw-sibling-promo-card__media" aria-hidden="true"></span>';
    var sub = venueName
      ? '<span class="wbw-sibling-promo-card__subtitle">Available in ' + escapeHtml(venueName) + '</span>'
      : '';
    return (
      '<a class="wbw-sibling-promo-card" href="' +
      escapeHtml(item.url) +
      '">' +
      img +
      '<span class="wbw-sibling-promo-card__body">' +
      '<span class="wbw-sibling-promo-card__title">' +
      escapeHtml(item.title) +
      '</span>' +
      sub +
      '<span class="wbw-sibling-promo-card__cta">Explore <span aria-hidden="true">→</span></span>' +
      '</span></a>'
    );
  }

  function panelHtml(items, eyebrow, venueName) {
    var cards = items
      .map(function (it) {
        return cardHtml(it, items.length === 1 ? venueName : '');
      })
      .join('');
    return (
      '<div class="wbw-sibling-promo-panel">' +
      '<p class="wbw-sibling-promo-panel__eyebrow">' +
      escapeHtml(eyebrow || 'Also available as') +
      '</p>' +
      '<div class="wbw-sibling-promo-grid' +
      (items.length === 1 ? ' wbw-sibling-promo-grid--single' : '') +
      '">' +
      cards +
      '</div></div>'
    );
  }

  var probeDone = Object.create(null);
  var probeInflate = Object.create(null);

  function probeSuffix(suffix, cityHandles, onDone) {
    if (!suffix || typeof onDone !== 'function') return;
    if (probeDone[suffix]) {
      onDone(false);
      return;
    }
    if (probeInflate[suffix]) {
      probeInflate[suffix].then(function (c) {
        onDone(!!c);
      });
      return;
    }
    var pending = PROBE_TEMPLATES.map(function (p) {
      return p + suffix;
    }).filter(function (h) {
      return h && !cityHandles[h];
    });
    if (!pending.length) {
      probeDone[suffix] = true;
      onDone(false);
      return;
    }
    var job = Promise.all(
      pending.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (res) {
            return res && res.ok ? h : '';
          })
          .catch(function () {
            return '';
          });
      })
    ).then(function (found) {
      var changed = false;
      found.forEach(function (h) {
        if (!h || cityHandles[h]) return;
        cityHandles[h] = true;
        changed = true;
      });
      probeDone[suffix] = true;
      probeInflate[suffix] = null;
      return changed;
    });
    probeInflate[suffix] = job;
    job.then(function (changed) {
      onDone(!!changed);
    });
  }

  function collectItems(root, data, cityHandles, catalog) {
    var current = String((root && root.getAttribute('data-product-handle')) || '')
      .trim()
      .toLowerCase();
    var suffix = citySuffix(root, current);
    var map = Object.create(null);

    function addHandle(raw) {
      var h = String(raw || '')
        .trim()
        .toLowerCase();
      if (!h || sameFamily(h, current) || h === current) return;
      var fam = workshopFamily(h);
      if (!fam || map[fam]) return;
      var meta = catalog.byHandle[h] || catalog.byFamily[fam] || null;
      map[fam] = {
        handle: h,
        title: String((meta && meta.title) || LABELS[fam] || LABELS[h] || fam).trim(),
        url: '/products/' + encodeURIComponent(h),
        image: String((meta && meta.image) || '').trim(),
      };
    }

    if (suffix) {
      Object.keys(cityHandles).forEach(function (h) {
        if (suffixFromHandle(h) === suffix) addHandle(h);
      });
    }

    return Object.keys(map).map(function (k) {
      return map[k];
    });
  }

  /** No future sessions → inplace waitlist only. "below" = dates exist + Can't make these dates. */
  function isWaitlistMode(root) {
    if (!root) return false;
    var branch = String(root.getAttribute('data-wcf-branch') || '').toLowerCase();
    if (branch === 'waitlist') return true;
    return String(root.getAttribute('data-pcw-waitlist-mode') || '').toLowerCase() === 'inplace';
  }

  function syncRoot(root) {
    if (!root) return;
    var sectionId = root.getAttribute('data-section-id') || '';
    var data = parseData(sectionId);
    var hosts = ensureHost(root, sectionId);
    if (!hosts.length) return;

    var cityHandles = Object.create(null);
    if (data && Array.isArray(data.cityProductHandles)) {
      data.cityProductHandles.forEach(function (h) {
        h = String(h || '')
          .trim()
          .toLowerCase();
        if (h) cityHandles[h] = true;
      });
    }
    var catalog = indexCatalog(data);
    var current = String(root.getAttribute('data-product-handle') || '')
      .trim()
      .toLowerCase();
    var suffix = citySuffix(root, current);
    var venueName = String(
      root.getAttribute('data-venue-name') || root.getAttribute('data-city-name') || ''
    ).trim();
    var eyebrow = String((data && data.siblingPromoEyebrow) || 'Also available as').trim();

    function paint() {
      if (isWaitlistMode(root)) {
        applyHosts(hosts, false, '');
        return;
      }
      var items = collectItems(root, data, cityHandles, catalog);
      if (!items.length) {
        applyHosts(hosts, false, '');
        return;
      }
      applyHosts(hosts, true, panelHtml(items, eyebrow, venueName));
    }

    paint();
    if (suffix) {
      probeSuffix(suffix, cityHandles, function (changed) {
        if (changed) paint();
      });
    }
    if (root.getAttribute('data-city-sibling-promo-obs') !== '1') {
      root.setAttribute('data-city-sibling-promo-obs', '1');
      if (typeof MutationObserver !== 'undefined') {
        new MutationObserver(function () {
          paint();
        }).observe(root, {
          attributes: true,
          attributeFilter: ['data-wcf-branch', 'data-pcw-waitlist-mode'],
        });
      }
    }
  }

  function boot() {
    document
      .querySelectorAll('[data-amc-shop-wizard], [data-popup-city-wizard]')
      .forEach(function (root) {
        if (root.getAttribute('data-city-sibling-promo') === '1') return;
        root.setAttribute('data-city-sibling-promo', '1');
        syncRoot(root);
      });
  }

  global.CitySiblingPromo = {
    sync: syncRoot,
    boot: boot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})(typeof window !== 'undefined' ? window : this);
